export default __webpack_public_path__ + "static/media/1808.d62859fc.png";